import React, { useState } from "react";
import { Tab, TabList, Tabs } from "@mui/joy";
import NewPayLinkSend from "./newpaylinksend";

/**
 * 결제관리 > '신규 결제링크' 메뉴 — 소탭 2개 (newtodo/components/winterregistermain.tsx 패턴).
 *  0 신규 결제링크 : 기존 신규 결제링크 (linkType != 'winter')
 *  1 윈터 결제링크 : 윈터 사전예약자 셀프 결제 링크 (linkType 'winter', 등록관리에서 일괄 발송한 것) — 제출 전 가상 행·진행 단계 포함
 * key 로 탭 전환 시 필터·선택 행이 초기화된다.
 */
const NewPayLinkMain: React.FC<any> = (props) => {

    const [sub, setSub] = useState<number>(0);

    return (
        <div style={{ width: "100%" }}>
            <Tabs
                size="sm"
                value={sub}
                onChange={(e: any, value: any) => setSub(+value)}
                sx={{ width: "96%", marginTop: "24px", backgroundColor: "transparent" }}
            >
                <TabList>
                    <Tab>신규 결제링크</Tab>
                    <Tab>윈터 결제링크</Tab>
                </TabList>
            </Tabs>

            {sub === 0 && <NewPayLinkSend key="register" mode="register" user={props.user} />}
            {sub === 1 && <NewPayLinkSend key="winter" mode="winter" user={props.user} />}
        </div>
    );
};

export default NewPayLinkMain;
